import type {MembershipExpandedCommon} from '../../../../api/membership';

import {membershipStore} from '../../../../api/membership';
import {logger} from '../../../../utils/logger';
import {AcceptRequestedMembershipsStrategy} from './AcceptRequestedMembershipsStrategy';

type Config = {
  memberships: MembershipExpandedCommon[];
};

export class AcceptGroupRequestedMembershipsStrategy extends AcceptRequestedMembershipsStrategy {
  constructor(private readonly config: Config) {
    super();
  }

  async execute(): Promise<void> {
    logger.event('request_accept_confirmation_tap');

    const {memberships} = this.config;

    const readyToAcceptMemberships: MembershipExpandedCommon[] = [];
    const invalidMemberships: MembershipExpandedCommon[] = [];

    memberships.forEach(membership => {
      if (membership.edition_id === membership.course?.edition_id) {
        readyToAcceptMemberships.push(membership);
      } else {
        invalidMemberships.push(membership);
      }
    });

    if (readyToAcceptMemberships.length) {
      await this.acceptMembershipsWithOwnTarget(readyToAcceptMemberships);
    }

    if (invalidMemberships.length) {
      await this.decline(invalidMemberships);
    }

    logger.event('request_accept_success_view');
  }

  private async acceptMembershipsWithOwnTarget(
    memberships: MembershipExpandedCommon[],
  ): Promise<void> {
    await membershipStore.coach.acceptBatch(
      memberships.map(entity => ({
        entity,
      })),
    );
  }
}
